import type { WrappedWatchlist } from "~types/octagon";
import { watchlistClient } from "~config/octagon-client";

const wc = watchlistClient.getInstance();

export async function getWrappedWatchlist(
  userId: string,
  watchlistId: number
): Promise<WrappedWatchlist> {
  const data = await wc.getWrappedWatchlist(userId, Number(watchlistId));

  return data as WrappedWatchlist;
}
